/* unplugin-vue-components disabled */import { render } from "./gannammap.vue?vue&type=template&id=487e7e04&scoped=true"
import script from "./gannammap.vue?vue&type=script&lang=js"
export * from "./gannammap.vue?vue&type=script&lang=js"

import "./gannammap.vue?vue&type=style&index=0&id=487e7e04&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487e7e04"]])

export default __exports__